import i18nRouteMeta from '@/app-core/mixins/i18n/i18nRouteMeta'
import {toLocaleUpperCase} from '@/core/lib/helpers/index.js'

export default {
  name      : 'MaintenanceMode',
  components: {},
  directives: {},
  mixins    : [i18nRouteMeta],
  props     : {},
  enums     : {},
  dataStore : {},
  data() {
    return {
      isLoading: false
    }
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    toLocaleUpperCase,

    onRetry() {
      this.isLoading = true
      setTimeout(() => {
        location.reload()
      }, 350)
    }
  }
}
